//Реакт
import React from "react";
//Стили
import "./styles.css";

export default function TableCol({children, onClick, className, ...other}){
    return <td onClick={onClick} className={`table__col ${className}`} {...other}>
        {children}
    </td>
}